// Geometry of the Hethera logo on a 512 grid, generated from
// brand/generate-logo.py (the source of truth). `full` is the main cut;
// `small` (bolder asterisks, wider gap) is for 48 px and below.
export const LOGO = {
  "stemW": 72,
  "left": 100,
  "right": 284,
  "top": 98,
  "bottom": 414,
  "barY": 180,
  "barH": 54,
  "cx": 330,
  "cy": 316,
  "angle": -28,
  "dx": 8
} as const;

export const LOGO_CUTS = {
  "full": {
    "bubble": "M-66.0 -38.0 H123.64 Q132.0 -38.0 125.92 -29.64 Q107.3 -10.64 94.0 1.8999999999999986 V10.0 Q94.0 38.0 66.0 38.0 H-66.0 Q-94.0 38.0 -94.0 10.0 V-10.0 Q-94.0 -38.0 -66.0 -38.0Z",
    "gap": 17,
    "stars": [
      [
        -52,
        1
      ],
      [
        0,
        1
      ],
      [
        52,
        1
      ]
    ],
    "starR": 17,
    "starT": 8.5
  },
  "small": {
    "bubble": "M-66.0 -38.0 H123.64 Q132.0 -38.0 125.92 -29.64 Q107.3 -10.64 94.0 1.8999999999999986 V10.0 Q94.0 38.0 66.0 38.0 H-66.0 Q-94.0 38.0 -94.0 10.0 V-10.0 Q-94.0 -38.0 -66.0 -38.0Z",
    "gap": 22,
    "stars": [
      [
        -54,
        1
      ],
      [
        0,
        1
      ],
      [
        54,
        1
      ]
    ],
    "starR": 17.5,
    "starT": 11
  }
} as const;
